import { FC } from 'react';

import { CloudinaryImage } from '../CloudinaryImage';

export const AuthLogo: FC = () => (
  <div className='d-flex justify-content-center mb-2'>
    <CloudinaryImage src='top-nav-logo.png' width={79} height={24} alt='Bezel Logo' />
  </div>
);
